import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PaymentCompany from './PayPalCompany.component';
import BillingAddress from './Details/BillingAddress';
import DiscountCode from './Details/Discount';

const CompanyPurchaseDetails = ({
  course,
  users = [],
  company,
  address,
  companyId,
}) => {
  const [discountCode, setDiscountCode] = useState('');
  const [discountAmount, setDiscountAmount] = useState(0);
  const [newAddress, setNewAddress] = useState(
    address || {
      street: '',
      city: '',
      province: '',
      postalCode: '',
    }
  );

  const taxRate = [
    { province: 'AB', rate: 0.05 },
    { province: 'BC', rate: 0.12 },
    { province: 'MB', rate: 0.12 },
    { province: 'NB', rate: 0.15 },
    { province: 'NL', rate: 0.15 },
    { province: 'NS', rate: 0.14 },
    { province: 'NT', rate: 0.05 },
    { province: 'NU', rate: 0.05 },
    { province: 'ON', rate: 0.13 },
    { province: 'PE', rate: 0.15 },
    { province: 'QC', rate: 0.14975 },
    { province: 'SK', rate: 0.11 },
    { province: 'YT', rate: 0.05 },
  ];

  const [taxAmount, setTaxAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  const selectedTax = newAddress?.province;
  let usersLength = users?.length || 0;
  const price = course?.price || 0;

  useEffect(() => {
    if (usersLength > 0) {
      const subTotal = price * usersLength;
      const discountValue = (subTotal * discountAmount) / 100;
      const discountedTotal = subTotal - discountValue;

      const taxRateForSelected =
        taxRate.find((rate) => rate.province === selectedTax)?.rate || 0;

      const calculatedTax = (discountedTotal * taxRateForSelected).toFixed(2); // Calculate tax on the discounted total
      const totalWithTax = (
        parseFloat(discountedTotal) + parseFloat(calculatedTax)
      ).toFixed(2);

      setTaxAmount(calculatedTax);
      setTotalAmount(totalWithTax);
    }
  }, [usersLength, price, discountAmount, selectedTax, taxRate, newAddress]);

  return (
    <>
      <aside className="cart">
        <h4>Cart</h4>
        {course.courseName && <h5>{course?.courseName}</h5>}
        {users?.map((u) => (
          <div
            key={u?._id}
            className="greyBorder spaceBetween"
            style={{
              padding: '0.3rem 0.3rem',
            }}
          >
            <p>
              {u?.firstName} {u?.lastName}
            </p>
            <p className="italic">${course?.price}</p>
          </div>
        ))}
        <div className="total">
          <p>
            Price:{' '}
            <span className="italic">${(price * usersLength).toFixed(2)}</span>
          </p>
          <p>
            Discount:{' '}
            <span className="italic">
              ({discountAmount}%) - $
              {((price * usersLength * discountAmount) / 100).toFixed(2)}
            </span>
          </p>
          <p>
            Tax: <span className="italic">${taxAmount}</span>
          </p>
          <p className="totalPrice">
            Grand Total: <span>${totalAmount}</span>
          </p>
        </div>
      </aside>

      <BillingAddress
        newAddress={newAddress}
        setNewAddress={setNewAddress}
        address={address}
        companyName={company?.companyName}
      />
      {/* Discount Code */}
      <DiscountCode
        setDiscountAmount={setDiscountAmount}
        setDiscountCode={setDiscountCode}
        discountCode={discountCode}
        companyId={company?._id}
      />
      {/* PAYPAL BUTTONS */}
      <aside className="ppbuttons">
        <h4>Payment</h4>
        <PaymentCompany
          courseName={course}
          billingAddress={newAddress}
          selectedUsers={users}
          discountCode={discountCode}
          courseId={course._id}
          companyId={companyId}
          total={(price * usersLength).toFixed(2)}
          tax={taxAmount}
          grandTotal={totalAmount}
          discount={((price * usersLength * discountAmount) / 100).toFixed(2)}
        />
      </aside>
    </>
  );
};

CompanyPurchaseDetails.propTypes = {
  course: PropTypes.shape({
    _id: PropTypes.string,
    courseName: PropTypes.string,
    price: PropTypes.number,
  }),
  users: PropTypes.arrayOf(PropTypes.object),
  company: PropTypes.object,
  address: PropTypes.object,
  setAddress: PropTypes.func,
  children: PropTypes.node,
  newAddress: PropTypes.object,
  companyId: PropTypes.string,
};

export default CompanyPurchaseDetails;
